import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import Toast from "../Toast";

export default function WatchAdModal({ isOpen, onClose, onComplete, onError }) {
    const [timer, setTimer] = useState(15);
    const [adLoaded, setAdLoaded] = useState(false);
    const adContainerRef = useRef(null);
    const intervalRef = useRef();
    const adTimeoutRef = useRef();
    const [toast, setToast] = useState({ message: "", type: "" });

    useEffect(() => {
        if (isOpen) {
            setToast({ message: "", type: "" });
            setTimer(15);
            setAdLoaded(false);

            setTimeout(() => {
                try {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                } catch (e) {
                    console.error("AdsbyGoogle push failed", e);
                }
            }, 500);

            adTimeoutRef.current = setTimeout(() => {
                if (!adLoaded) {
                    onError("Ad failed to load. Please try again later.");
                    onClose();
                }
            }, 5000);
        }

        return () => {
            clearInterval(intervalRef.current);
            clearTimeout(adTimeoutRef.current);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (adLoaded && isOpen) {
            intervalRef.current = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }
    }, [adLoaded, isOpen]);

    useEffect(() => {
        if (timer === 0) {
            clearInterval(intervalRef.current);
            setToast({ message: "🎉 Credit Earned!", type: "success" });
            onComplete();
            onClose();
        }
    }, [timer, onComplete, onClose]);

    const handleAdLoad = () => {
        clearTimeout(adTimeoutRef.current);
        setAdLoaded(true);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center">
            <motion.div
                className="relative bg-white p-6 rounded-xl shadow-2xl max-w-md w-full text-center"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.3 }}
            >
                {/* Toast inside Modal */}
                {toast.message && (
                    <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: "", type: "" })} />
                )}

                <h2 className="text-xl font-bold text-[#166CB0] mb-4">
                    Watch Ad to Earn Credit
                </h2>

                <div className="my-4" ref={adContainerRef}>
                    <ins
                        className="adsbygoogle"
                        style={{ display: "block" }}
                        data-ad-client="ca-pub-6063063628146000"
                        data-ad-slot="3443184854"
                        data-ad-format="auto"
                        data-full-width-responsive="true"
                        onLoad={handleAdLoad}
                    ></ins>
                </div>

                {!adLoaded && (
                    <p className="text-gray-500 text-sm mb-2">Loading ad...</p>
                )}

                {adLoaded && (
                    <div className="mt-4 text-gray-600 text-sm">
                        Please wait {timer} second{timer !== 1 && "s"}...
                    </div>
                )}

                <button
                    onClick={() => {
                        clearInterval(intervalRef.current);
                        clearTimeout(adTimeoutRef.current);
                        onClose();
                    }}
                    className="mt-6 text-red-500 underline text-sm"
                >
                    Cancel
                </button>
            </motion.div>
        </div>
    );
}
